/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 08-09-2026
 *
 * De modal waarin een foutmelding aan de gebruiker getoond wordt: de ng21-tegenhanger van de
 * AngularJS-`erroralert` (golf a3). Eén regel tekst en een OK-knop; de tekst is al vertaald door
 * `FoutmeldingService`, die deze modal opent.
 *
 * Staat `vraag` aan, dan komen er in plaats van OK een ja- en een nee-knop en krijgt de aanroeper
 * het antwoord terug. Dat is voor een fout waar de gebruiker iets over te zeggen heeft — een model
 * dat niet meer bestaat, bijvoorbeeld: opslaan als nieuw model, of niet?
 */
import {Component, inject} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {BaseIslandComponent} from '../../base-island.component';

@Component({
    selector: 'dl-foutmelding',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './dl-foutmelding.component.html',
    styleUrls: ['./dl-foutmelding.component.scss']
})
export class DlFoutmeldingComponent extends BaseIslandComponent {

    /**
     * De vertaalde meldingstekst; meegegeven via de `initialState` van de modal.
     */
    melding = '';

    /**
     * Toon een ja- en een nee-knop in plaats van OK, en geef het antwoord terug.
     */
    vraag = false;

    /**
     * Wordt aangeroepen zodra de gebruiker geantwoord heeft, zodat de aanroeper weet dat de melding
     * gezien is. Bij een gewone melding is het antwoord altijd `false`.
     */
    resolve!: (akkoord: boolean) => void;

    private readonly modalRef = inject(BsModalRef);

    constructor() {
        super();
    }

    /**
     * Sluit de melding met het gegeven antwoord.
     */
    protected sluit(akkoord = false): void {
        this.resolve(akkoord);
        this.modalRef.hide();
    }
}
